module.exports = __webpack_public_path__ + "media/images/how_it_works/environment-30911b691c1abd08b2bc94fdff5445c2.svg";